module.exports = __webpack_public_path__ + "img/imagen8.3185b90a.png";